import React from 'react';
import cn from 'classnames';
import {createUseStyles} from 'react-jss';

export default function IconInfo({
                                   className, height = '1em', title = ''
                                 }) {
  const styles = useStyles();
  const viewBox = '0 0 20 20';

  return (
    <svg className={cn(className, 'inline-block', styles.icon)} xmlns="http://www.w3.org/2000/svg" height={height}
         viewBox={viewBox}
         aria-labelledby={title}>
      <path
        d="M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z"
        fill="currentColor"/>
      <path d="M10 6.5H10.0056" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9 9.25H9.99998V13.25H11" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

const useStyles = createUseStyles({
  icon: {
    verticalAlign: '-0.125em',
  },
});
